import { render, staticRenderFns } from "./ResellerInvoiceViewDetailsResellerInvoiceItemTable.vue?vue&type=template&id=67a68839"
import script from "./ResellerInvoiceViewDetailsResellerInvoiceItemTable.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceViewDetailsResellerInvoiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./ResellerInvoiceViewDetailsResellerInvoiceItemTable.vue?vue&type=style&index=0&id=67a68839&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports